import React, { useState } from 'react';
import styled from 'styled-components';
import { DropdownPanel } from '../DropdownPanel';
import { VerticalNavigation } from './';
import { isCurrentSite, isFieldValid } from '../../utils/validation';
import { DownArrowSVG } from '../Icon';
import { NavigationLink } from '../Link';
import { OnBodyClickWrapper } from '../UtilityWrappers/OnBodyClickWrapper';
import media from '../../utils/media';
import { getSiteName } from '../../utils/helpers';
import { populateNavigationGTM } from '../../utils/gtm';
const StyledContainer = styled.ul `
  ${media.mobile} {
    display: none;
  }

  display: flex;
  list-style: none;
  margin: 0;
  padding-left: 0;
  justify-content: space-around;
  z-index: auto;
  flex-grow: 2;
`;
const ItemContainer = styled.li `
  position: relative;
  z-index: auto;
  box-sizing: initial;
  margin-right: 30px;

  .nav-label {
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.primaryBlack};
    font-family: ${({ theme }) => theme.fontFamilyBold};
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.primaryRed};
    }

    ${media.mobile} {
      font-size: 14px;
    }
  }
`;
const Nav = styled.nav `
  width: 100%;
`;
const LabelContainer = styled.div `
  transition: all 0.5s ease;
  border: none;
  display: flex;
  align-items: center;
  margin: 0;
  height: 74px;
`;
const SecondNavLabelContainer = styled.div `
  cursor: pointer;
  display: flex;
`;
const DownArrowContainer = styled.div `
  padding: 0px 6px 0px 6px;
  transform: ${({ shouldImageFlip }) => (shouldImageFlip ? 'scale(-1, -1)' : 'none')};
  display: flex;
  align-items: center;
`;
const SiteIndicator = styled.div `
  position: absolute;
  height: 3px;
  width: 100%;
  background-color: ${({ theme }) => theme.primaryRed};
  bottom: 0px;
  left: 0px;
  display: ${({ isHighlighted }) => (isHighlighted ? 'block' : 'none')};
`;
export const Navigation = ({ currentSite, navigationItems, siteOwner, currentLanguage, }) => {
    // state handler for nav item indicator
    const [isChildNavSelected, setIsChildNavSelected] = useState(null);
    const toggleChildNav = (index) => setIsChildNavSelected(index);
    if (!navigationItems)
        return null;
    return (React.createElement(Nav, { "aria-label": "primary-navigation" },
        React.createElement(StyledContainer, null, navigationItems.map(({ fields }, index) => {
            const { url, label, items, notVisible } = fields;
            // by default, notVisible value is false
            // if true, do not render
            if (isFieldValid(notVisible)) {
                return null;
            }
            // renders child nav with clickable text
            if (items && label && label.value) {
                const shouldChildNavOpen = isChildNavSelected === index;
                return (React.createElement(ItemContainer, { key: index.toString() },
                    React.createElement(OnBodyClickWrapper, { shouldComponentCareAboutOutsideClicks: shouldChildNavOpen, handleComponentExitOperation: () => toggleChildNav(null) },
                        React.createElement(LabelContainer, null,
                            React.createElement(SecondNavLabelContainer, { role: "button", tabIndex: 0, onMouseDown: () => (shouldChildNavOpen ? toggleChildNav(null) : toggleChildNav(index)), onFocus: () => toggleChildNav(index), onBlur: () => toggleChildNav(null) },
                                React.createElement("span", { className: "nav-label" }, label.value),
                                React.createElement(DownArrowContainer, { shouldImageFlip: shouldChildNavOpen },
                                    React.createElement(DownArrowSVG, null)),
                                React.createElement(SiteIndicator, { isHighlighted: shouldChildNavOpen }),
                                React.createElement(DropdownPanel, { shouldDisplayDropdown: shouldChildNavOpen },
                                    React.createElement(VerticalNavigation, { currentLanguage: currentLanguage, currentSite: currentSite, navigationItems: items, siteOwner: siteOwner, allowContentToBeTabable: shouldChildNavOpen, navigationType: "secondary-navigation" })))))));
            }
            // renders normal link
            else if (label && url) {
                let siteName = getSiteName(url);
                siteName = siteName === '' ? (currentLanguage.startsWith('en') ? 'home' : 'accueil') : siteName;
                const { text: ariaLabel } = url.value;
                return (React.createElement(ItemContainer, { key: index.toString() },
                    React.createElement(LabelContainer, null,
                        React.createElement(NavigationLink, Object.assign({ to: `/${siteName}`, ariaLabel: ariaLabel }, populateNavigationGTM(fields)), label.value),
                        React.createElement(SiteIndicator, { isHighlighted: !isChildNavSelected && isCurrentSite(currentSite, siteName) }))));
            }
            else {
                // value is falsy
                return null;
            }
        }))));
};
